<app-content-viewer [content]="content" (click)="breadcrumbElemClicked($event)"></app-content-viewer>
